import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import React, { BaseSyntheticEvent } from 'react'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getInitialAssessmentSelector } from '../selectors'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import InitialAssessmentCommentsContent from './InitialAssessmentCommentsContent'

const InitialAssessmentComments: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const fieldComment: any = history?.location?.state
  const { selectedOption } = useSelector(getInitialAssessmentSelector)
  const title: any =
    (selectedOption === InitialAssessmentConstants.NEURO && 'Neuro Comments') ||
    (selectedOption === InitialAssessmentConstants.AIRWAY && 'Airway Comments') ||
    (selectedOption === InitialAssessmentConstants.CARDIO && 'Cardio Comments') ||
    (selectedOption === InitialAssessmentConstants.RESPIRATORY && !fieldComment && 'Respiratory Comments') ||
    (fieldComment && 'Breath Sounds Comments') ||
    ''

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.INITIAL_ASSESSMENT)
  }
  const saveOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
  }

  return (
    <>
      <IonPage id='InitialAssessmentCommentsPage'>
        <PCRHeader />
        <IonHeader>
          <IonToolbar className='toolbarBorder' color='light'>
            <IonButtons slot='start'>
              <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
            <IonTitle data-testid='HeaderTitle'>{title}</IonTitle>
            <IonButtons slot='end'>
              <IonButton data-testid='Save' color='primary-alt' fill='clear' onClick={saveOnClick}>
                {t('common.buttons.Save')}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent id='main-pn-content' color='light' fullscreen>
          <InitialAssessmentCommentsContent title={title} fieldComment={fieldComment} selectedOption={selectedOption} />
        </IonContent>
      </IonPage>
    </>
  )
}

export default InitialAssessmentComments
